import Account              from "../../../domain/account/Account";
import AccountOptionTypes   from "../../../domain/account/AccountOptionTypes";
import AccountPlanType      from "../../../domain/account/AccountPlanType";
import AccountPlanTypeClass from "../../../domain/account/AccountPlanTypeClass";
import AccountRepository    from "../../../domain/account/AccountRepository";
import AccountRoleType      from "../../../domain/account/AccountRoleType";
import AccountRoleTypeClass from "../../../domain/account/AccountRoleTypeClass";
import Authentication       from "../../../domain/authentication/Authentication";
import AccountDataSource    from "../../../infrastructure/datasource/account/AccountDataSource";
import RouterDispatcher     from "../../../infrastructure/redux/router/RouterDispatcher";
import GetAuthentication    from "./GetAuthentication";
import IdentifyLogRocket    from "./IdentifyLogRocket";
import LoginResKa           from "./LoginResKa";
import SaveAuthentication   from "./SaveAuthentication";

class AutoLoginResKa {
  private readonly getAuthentication: GetAuthentication = new GetAuthentication();
  private readonly saveAuthentication: SaveAuthentication = new SaveAuthentication();
  private readonly loginResKa: LoginResKa = new LoginResKa();
  private readonly identifyLogRocket: IdentifyLogRocket = new IdentifyLogRocket();
  private readonly accountRepository: AccountRepository = new AccountDataSource(this.dispatch);
  private readonly routerDispatcher: RouterDispatcher = new RouterDispatcher(this.dispatch);

  constructor(private readonly dispatch) {
  }

  public async execute(callback: (value: boolean) => void) {
    const authentication: Authentication = this.getAuthentication.execute();
    if (authentication.autoLogin.value) {
      this.saveAuthentication.execute(authentication);
      callback(true);
      try {
        const response = await this.loginResKa.execute(authentication);
        this.identifyLogRocket.execute(response.data ? response.data.name : "法人名がありません");
        const account: Account = new Account(
          new AccountRoleTypeClass(response.data ? response.data.role : AccountRoleType.NONE),
          new AccountPlanTypeClass(response.data ? response.data.plan : AccountPlanType.PLAN_NONE),
          new AccountOptionTypes(response.data ? response.data.options : [])
        );
        this.accountRepository.store(account);
        this.routerDispatcher.notice();
      } catch (e) {

      } finally {
        callback(false);
      }
    }
  }

}

export default AutoLoginResKa;
